import React from "react";

// 申請ステータスのバッジ（記録のみ/申請中/承認/却下）。
// 休み申請・時間訂正・残業・承認リスト・日別勤怠で共通利用する。
// status が STATUS_META に無ければ status 文字列をそのまま mp-offday で表示（従来のフォールバック踏襲）。
// className は追加クラス（例：日別勤怠の mp-att-app-status）を足したいとき用。
export const STATUS_META = {
  recorded: { text: "記録のみ", cls: "mp-offday" },
  pending: { text: "申請中", cls: "mp-pending" },
  approved: { text: "承認", cls: "mp-approved" },
  rejected: { text: "却下", cls: "mp-rejected" },
};

export default function StatusBadge({ status, className }) {
  const meta = STATUS_META[status] || { text: status, cls: "mp-offday" };
  return (
    <span className={`mp-bd ${meta.cls}${className ? ` ${className}` : ""}`}>
      {meta.text}
    </span>
  );
}
